import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import './Success.css'
const Success = () => {

    return (
        <div className='container'>
            <Header></Header>
            <div className="top-text text-center">
                   <h1>Successful Students</h1>
                    <p>Below are the profiles of some of the people who have learned from our course and got jobs / interns in       different places</p>
            </div>
        <div className="main">
        <div className="content ">
            <div className="container-content">
                <div>
                    <Link href="" target="_blank"><img className="success-people" src="https://images.freeimages.com/images/premium/previews/3843/38439378-happy-indian-man.jpg" alt="img" width="50px" height="50px" /></Link>
                </div>
                <div>
                    <p>I am a very hard-working person but I could not find the right path to success, programming-hero has guided me on the right path with utmost care. Their education sy </p>
                    <p className="bottom-text">Microsoft</p>
                </div>
            </div>      
        </div>
        <div className="content">
            <div className="container-content ">
                <div>
                    <Link href="" target="_blank"><img className="success-people" src="https://images.unsplash.com/photo-1604695753685-20e756f4aa61?ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8Ym95JTIwZmFjZXxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&w=1000&q=80" alt="img" width="50px" height="50px"/></Link>
                </div>
                <div>
                    <p>I will always be thankful to the programming hero team. Their guideline, support, motivation, especially the process of their mentoring system outstanding.</p>
                    <p className="bottom-text">Microsoft</p>
                </div>
            </div>
        </div>
        <div className="content">
            <div className="container-content">
                <div>
                    <Link href="" target="_blank"><img className="success-people" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR2qtx-hhVZuD9cm50g88Vnj-ZJnSrBvebITw&usqp=CAU" alt="img" width="50px" height="50px"/></Link>
                </div>
                <div>
                    <p>I am from a different engineering background. The overall course structure of Programming Hero is pretty well organized. Working on various projects as assignments h</p>
                    <p className="bottom-text">Microsoft</p>
                </div>
            </div>
        </div>
        <div className="content">
            <div className="container-content">
                <div>
                    <Link href="" target="_blank"><img className="success-people" src="https://i.pinimg.com/originals/c4/49/8e/c4498e93efb3ed316296bdaf33e17f93.jpg" alt="img" width="50px" height="50px"/></Link>
                </div>
                <div>
                    <p>Thanks a Lot to the Programming Hero Team, because they are also a fun and personalized platform. in this day, my dream is also full fill.</p>
                    <p className="bottom-text">Microsoft</p>
                </div>
            </div>
        </div>
        <div className="content">
            <div className="container-content">
                <div>
                    <Link href="" target="_blank"><img className="success-people" src="tbn:ANd9GcTvhOQs0ba2Q56LkuvrevgH2cZsnivwqPZKd_XQ6AZ75CCJRiSyNCAA409YbuBtksRvs3c" alt="img" width="50px" height="50px"/></Link>
                </div>
                <div>
                    <p>I am so thankful to Jhankar Mahbub sir. I also thank all my Programming Hero coursemates. They are so helpful. They give their best for us. Jhankar Mahbub is one of </p>
                    <p className="bottom-text">Microsoft</p>
                </div>
            </div>
        </div>
        <div className="content">
            <div className="container-content">
                <div>
                    <Link href="" target="_blank"><img className="success-people" src="https://i.pinimg.com/originals/95/e6/74/95e6748a7a97678f7df69e50c6b9c223.jpg" alt="img" width="50px" height="50px"/></Link>
                </div>
                <div>
                    <p>Firstly I thanks, Almighty Allah. Then the programming hero team. They build me a soldier. Now I can face any problem that will come into my life. They help to overc</p>
                    <p className="bottom-text">Microsoft</p>
                </div>
            </div>
        </div>
        <div className="content">
            <div className="container-content">
                <div>
                    <Link href="" target="_blank"><img className="success-people" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQLC3br14slq7qRR8KL9IjP3JsjZx4YJ5KJIvbVSaBZA6LYBrm4uPwz-e07Qx_xxHq0wpQ&usqp=CAU" alt="img" width="50px" height="50px"/></Link>
                </div>
                <div>
                    <p>Programming Hero is such an amazing learning platform that offers complete package of Web Development. The uniqueness of programming hero is, It’s Impactful syllabus </p>
                    <p className="bottom-text">Microsoft</p>
                </div>
            </div>
        </div>
        <div className="content">
            <div className="container-content">
                <div>
                    <Link href="" target="_blank"><img className="success-people" src="https://nextluxury.com/wp-content/uploads/mens-short-hairstyles-for-curly-hair.jpg" alt="img" width="50px" height="50px"/></Link>
                </div>
                <div>
                    <p>The beginning of my programming life when Corona was blust. The varsity closed, spending time in laziness. Suddenly it occurred to me to learn to program and create</p>
                    <p className="bottom-text">Microsoft</p>
                </div>
            </div>
        </div>
        <div className="content">
            <div className="container-content">
                <div>
                    <Link href="" target="_blank"><img className="success-people" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRXIJWFSUAyixXv3iPM0cwp7tqpoVohUIJzuzHosUmJKHzM_P__YEV0UbwFPKB9Y0y1CuY&usqp=CAU" alt="img" width="50px" height="50px"/></Link>
                </div>
                <div>
                    <p>My sincere thanks and gratitude to the Programming Hero team for their support and dedication that aid me like a pioneer to move towards the final destination.</p>
                    <p className="bottom-text">Microsoft</p>
                </div>
            </div>
        </div>
        
    </div>
    <Link className="text-center find-more">See More</Link>
    <Footer></Footer>
    </div>
    );
};

export default Success;